const communityImpacts = document.querySelectorAll(".community-impact-block");

communityImpacts.forEach(communityBlock => {
	const tabButtons = communityBlock.querySelectorAll(".js-tab-button");
		const tabs: null | NodeListOf<HTMLElement> = communityBlock.querySelectorAll(".tab-content .js-tab");

	tabButtons.forEach((button, index) => {
		function makeActive(nodeList, index) {
			nodeList.forEach((button) => {
				if (button.dataset.tabId == index) {
					button.classList.add("active");
				} else {
					button.classList.remove("active");
				}
			});
		}
		tabButtons.forEach((button) => {
			button.addEventListener("click", (e) => {
				const activeButton: HTMLElement = e.target as HTMLElement;
				const index = activeButton.dataset.tabId;

				makeActive(tabButtons, index);

				makeActive(tabs, index);
			});
		});
	});
	document.addEventListener('DOMContentLoaded', () => {
		if (tabButtons[0]) {
			const button = tabButtons[0] as HTMLButtonElement;
			button.click();
		}
	})
})
